// Ícono "Asistente" del header (junto a notificaciones). Solo para la allowlist.
import React from 'react';
import { IconButton, Tooltip } from '@chakra-ui/react';
import { FaRobot } from 'react-icons/fa';
import { useAsistente } from './AsistenteContext';

const AsistenteBoton = () => {
  const { habilitado, abierto, alternar } = useAsistente();
  if (!habilitado) return null;
  return (
    <Tooltip hasArrow label="Asistente (Ctrl+K)">
      <IconButton
        aria-label="Asistente"
        aria-pressed={abierto}
        icon={<FaRobot />}
        variant={abierto ? 'solid' : 'ghost'}
        colorScheme={abierto ? 'blue' : undefined}
        borderRadius="full"
        onClick={alternar}
        flexShrink={0}
      />
    </Tooltip>
  );
};

export default AsistenteBoton;
